var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 17,
    viewBox: "0 0 11 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2C7.43 2 9 3.57 9 5.5C9 7.43 7.43 9 5.5 9C3.57 9 2 7.43 2 5.5C2 3.57 3.57 2 5.5 2ZM6.5 10.91C7.76408 10.6763 8.90636 10.0071 9.72842 9.01884C10.5505 8.03054 11.0004 6.78551 11 5.5C11 2.46 8.54 0 5.5 0C2.46 0 2.54686e-07 2.46 2.54686e-07 5.5C-0.000390782 6.78551 0.449519 8.03054 1.27158 9.01884C2.09364 10.0071 3.23592 10.6763 4.5 10.91V13H3.5C2.95 13 2.5 13.45 2.5 14C2.5 14.55 2.95 15 3.5 15H4.5V16C4.5 16.55 4.95 17 5.5 17C6.05 17 6.5 16.55 6.5 16V15H7.5C8.05 15 8.5 14.55 8.5 14C8.5 13.45 8.05 13 7.5 13H6.5V10.91Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/Female.51790048d5251abda29f81dab1e4a14c.svg";
export { ForwardRef as ReactComponent };